export default "__VITE_ASSET__737074a7__"